module.exports = __webpack_public_path__ + "static/media/icon-coin-contact-bottom.443ca8d6.png";